import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';


export interface IDataPermitDialog {
  permitIssuer: string;
  permitIssuedDate: Date;
  permitPlanType: string;
  permitNumber: string;
}

@Component({
  selector: 'ebb-portal-dialog-permit',
  templateUrl: './dialog-permit.component.html'
})
export class DialogPermitComponent implements OnInit {
  public formPermitInfo: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<DialogPermitComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDataPermitDialog,
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.InitializeForms();
    this.loadPermitInfoForm();
  }

  private InitializeForms(): void {
    // Permit info
    this.formPermitInfo = this.fb.group({
      permitIssuer: '',
      permitNumber: '',
      permitPlanType: '',
      permitIssuedDate: ''
    });
  }

  private loadPermitInfoForm(): void {
    if (this.data.permitIssuer && this.data.permitIssuer.length > 0)
      this.formPermitInfo.get('permitIssuer').setValue(this.data.permitIssuer);

    const permitDateUTC = new Date(this.data.permitIssuedDate);
    permitDateUTC.setHours(permitDateUTC.getHours()+8);
    const permitDatePST = new Date(permitDateUTC);
    const permitIssuedDate: Date = new Date(permitDatePST);

    if (this.data.permitIssuedDate)
      this.formPermitInfo.get('permitIssuedDate').setValue(permitIssuedDate.toDateString())

    if (this.data.permitPlanType && this.data.permitPlanType.length > 0)
      this.formPermitInfo.get('permitPlanType').setValue(this.data.permitPlanType)

    if (this.data.permitNumber && this.data.permitNumber.length > 0)
      this.formPermitInfo.get('permitNumber').setValue(this.data.permitNumber)

  }

  onClickClose(): void {
    this.dialogRef.close();
  }

}
